import { Header } from "./Header";
import { Hero } from "./Hero";
import { Features } from "./Features";

interface LandingPageProps {
  onLoginClick?: () => void;
  onTryFreeClick?: () => void;
}

export function LandingPage({ onLoginClick, onTryFreeClick }: LandingPageProps) {
  return (
    <div className="bg-white w-full">
      <Header onLoginClick={onLoginClick} onTryFreeClick={onTryFreeClick} />
      <Hero onTryFreeClick={onTryFreeClick} />
      <Features onTryFreeClick={onTryFreeClick} />
    </div>
  );
}

